module.exports = __webpack_public_path__ + "img/1.bd569cf9.jpg";